import { useGetThumbnail } from 'hooks/useGetThumbnail';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { MiniPlan } from 'screens/AssessmentScreen/Repeatable/MiniPlan';
import { API_ASE_IMAGE } from 'service/api/constants';
import {
  selectAseAssetPlan,
  selectAseId,
  selectAseIsOnline,
} from 'store/assessments/selectors';
import { selectUrlToken } from 'store/auth/selectors';

type Props = {
  style?: StyleProp<ViewStyle>;
  // eslint-disable-next-line react/no-unused-prop-types
  assetId?: undefined;
  planId: string;
  x: number;
  y: number;
  maxWidth: number;
  maxHeight: number;
};

export const MiniPlanAssessment: React.FC<Props> = ({
  style,
  planId,
  maxWidth,
  maxHeight,
  x,
  y,
}) => {
  const urlToken = useSelector(selectUrlToken);
  const assessmentId = useSelector(selectAseId);
  const isOnline = useSelector(selectAseIsOnline);

  const plan = useSelector((state) => selectAseAssetPlan(state, planId));
  const fileId = plan
    ? `${plan.fileId}${plan.filePage ? `:${plan.filePage}` : ''}`
    : undefined;

  const { image } = useGetThumbnail(!isOnline && fileId ? fileId : '') || {
    image: undefined,
  };

  if (!plan || !fileId || (!isOnline && !image)) {
    return null;
  }

  return (
    <MiniPlan
      style={style}
      image={
        image ||
        API_ASE_IMAGE(assessmentId, {
          size: 's',
          urlToken,
        })(fileId)!
      }
      x={x}
      y={y}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
    />
  );
};
